var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIndicatorAutoanswerRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "white",
    stroke: "#AD36F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88369 9.03778L8.82712 6.2201C8.77509 6.09513 8.72106 5.94673 8.66503 5.7749C8.609 5.60307 8.55297 5.41757 8.49694 5.2184C8.44491 5.41757 8.39088 5.60502 8.33485 5.78076C8.27882 5.95259 8.22479 6.10295 8.17277 6.23182L7.1222 9.03778H9.88369ZM12.7352 12.2362H11.4866C11.3465 12.2362 11.2324 12.203 11.1444 12.1366C11.0563 12.0663 10.9903 11.9804 10.9463 11.8789L10.2979 10.1508H6.70197L6.05362 11.8789C6.0216 11.9687 5.95957 12.0507 5.86752 12.1249C5.77547 12.1991 5.66141 12.2362 5.52533 12.2362H4.26465L7.6805 3.76562H9.32539L12.7352 12.2362Z",
    fill: "#AD36F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndicatorAutoanswerRead);
export default __webpack_public_path__ + "static/media/icon-indicator-autoanswer-read.8e7835c71f45d6f6a58dbe5d7519797d.svg";
export { ForwardRef as ReactComponent };